import React, { Component } from 'react';
import TextInput from 'Components/Ant/Input';
import PropTypes from 'prop-types';
import { noop } from 'Helpers/PropTypes';
import NormalizedInput from '..';

import './index.css';

class TextareaInput extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    const { name, onChange } = this.props;
    onChange(name, e.target.value);
  }

  render() {
    const { handleChange } = this;
    const {
      className,
      minRows,
      onBlur,
      test,
      maxRows,
      ...rest
    } = this.props;

    return (
      <NormalizedInput>
        <TextInput.TextArea
          {...rest}
          className={`Textarea ${className}`}
          type="text"
          onChange={handleChange}
          onBlur={onBlur}
          test={test}
          autosize={{ minRows, maxRows }}
        />
      </NormalizedInput>
    );
  }
}

TextareaInput.propTypes = {
  className: PropTypes.string,
  maxLength: PropTypes.number,
  minRows: PropTypes.number,
  maxRows: PropTypes.number,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  value: PropTypes.string,
  test: PropTypes.string,
};

TextareaInput.defaultProps = {
  className: '',
  maxLength: 255,
  minRows: 2,
  maxRows: 10,
  onBlur: noop,
  onChange: noop,
  value: '',
  test: '',
};

export default TextareaInput;
